<template lang="pug">
  //- 1col, sm: 2col
  .cart-item.sm-flex.justify-between.items-center.px-20.md-px-50.lg-px-0(:class="{'opacity-50 pointer-events-none': status}")
    //- left col: image
    figure.sm-w-1x2.px-20.md-px-50.lg-pl-75.xl-pl-100.mb-30.sm-mb-0
      .relative.pb-ar-2x3.w-full.lg-max-w-300.mx-auto.bg-gray-300
        img.absolute.overlay.object-cover.object-center.transition-opacity.duration-300(:src="item.variant.image.transformedSrc", :alt="item.variant.image.altText", v-if="item.variant.image", :class="{'opacity-0': !imgLoaded}", @load="imgLoaded = true")
    .w-24.hidden.lg-block
    //- right col
    header.sm-w-1x2.px-20.md-px-50
      .mx-auto.max-w-400.text-16.lg-text-17
        //- title
        h6.mb-15.text-center {{ item.title }}<br>{{ item.variant.title }}
        ul.leading-2xl.lg-leading-normal
          li.flex.justify-between
            div Price
            div {{ price(item.variant.priceV2.amount) }}
          li.flex.justify-between
            div Quantity
            //- edit quantity
            input.input-qty.border.border-gray-300.lg-border-transp.lg-hover-border-gray-300.text-center.lg-text-right.bg-transp.lg-pr-6.lg--mr-6.w-50.focus-border-blue.pt-2(v-model="qty", type="number", min="0", size="2", @click="e => e.target.select()", :disabled="status !== null", @keydown.enter="e => e.target.blur()", @blur="updateQuantity")
          li.flex.justify-between(v-if="item.quantity > 1")
            div Subtotal
            div {{ price(item.quantity * item.variant.priceV2.amount) }}
        footer.w-full.text-center.leading-xl
          button.text-gray-400.hover-text-black.focus-text-blue(@click="removeItem", :disabled="status !== null")
            | {{ status ? status : 'Remove' }}
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'CartItem',
  props: ['item'],
  data () {
    return {
      status: null,
      qty: 0,
      imgLoaded: false
    }
  },
  computed: {
    ...mapState({ checkout: state => state.shop.checkout }),
    ...mapGetters({ price: 'shop/price' }),
    lineItems () {
      return !this.checkout ? []
        : this.checkout.lineItems.map(itm => ({ variantId: itm.variant.id, quantity: itm.quantity }))
    },
    lineItemIndex () {
      // index position of line item in checkout.lineItems
      return this.lineItems.findIndex(itm => itm.variantId === this.item.variant.id)
    }
  },
  methods: {
    async removeItem () {
      const i = this.lineItemIndex
      if (i > -1) {
        this.status = 'Removing...'
        const newItems = [...this.lineItems]
        newItems.splice(i, 1)
        await this.$store.dispatch('shop/updateCheckoutItems', newItems)
        this.status = null
      }
    },
    async updateQuantity () {
      const qty = Math.max(0, Number(this.qty))
      if (qty === this.item.quantity) return
      // remove
      if (qty === 0) return this.removeItem()
      // update
      const i = this.lineItemIndex
      if (i > -1) {
        this.status = 'Updating...'
        const newItems = [...this.lineItems]
        newItems[i].quantity = qty
        await this.$store.dispatch('shop/updateCheckoutItems', newItems)
        this.status = null
      }
    }
  },
  watch: {
    item () {
      this.qty = this.item.quantity
    }
  },
  created () {
    this.qty = this.item.quantity
  }
}
</script>

<style>
input.input-qty::-webkit-outer-spin-button,
input.input-qty::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type=number].input-qty {
  appearance:none;
  /* Firefox */
  -moz-appearance: textfield;
}
</style>
